var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 100,
    viewBox: "0 0 68 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1617 100C26.3617 100 33.8284 92.5334 33.8284 83.3334V66.6667H17.1617C7.96172 66.6667 0.495056 74.1334 0.495056 83.3334C0.495056 92.5334 7.96172 100 17.1617 100Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.495056 49.9999C0.495056 40.7999 7.96172 33.3333 17.1617 33.3333H33.8284V66.6665H17.1617C7.96172 66.6665 0.495056 59.1999 0.495056 49.9999Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.495056 16.6667C0.495056 7.46666 7.96172 0 17.1617 0H33.8284V33.3333H17.1617C7.96172 33.3333 0.495056 25.8667 0.495056 16.6667Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8284 0H50.4951C59.6951 0 67.1618 7.46666 67.1618 16.6667C67.1618 25.8667 59.6951 33.3333 50.4951 33.3333H33.8284V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1618 49.9999C67.1618 59.1999 59.6951 66.6665 50.4951 66.6665C41.295 66.6665 33.8284 59.1999 33.8284 49.9999C33.8284 40.7999 41.295 33.3333 50.4951 33.3333C59.6951 33.3333 67.1618 40.7999 67.1618 49.9999Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.7443c62bea902b30bf6d3e70501ecf46.svg";
export { ForwardRef as ReactComponent };